import { Skeleton } from "@/components/ui/skeleton";

const shimmerClassName = "from-gray-100 via-gray-200 to-gray-100";
const iconShimmerClassName = `${shimmerClassName} shrink-0`;

const SpanCardShimmer = ({ animationDelayMs = 0 }: { animationDelayMs?: number }) => (
  <div
    aria-hidden="true"
    className="relative shrink-0 rounded-md border border-gray-200 bg-white px-3.5 py-3 text-xs font-medium text-gray-500 duration-300 ease-out animate-in fade-in-0 slide-in-from-top-1"
    style={{
      animationDelay: `${animationDelayMs}ms`,
      animationFillMode: "both",
    }}
  >
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-1.5 overflow-hidden">
        <Skeleton className={iconShimmerClassName} width="14px" height="14px" borderRadius="4px" />
        <Skeleton className={shimmerClassName} width="62%" height="12px" borderRadius="3px" />
        <div className="ml-auto flex shrink-0 items-center gap-1.5">
          <Skeleton
            className={iconShimmerClassName}
            width="12px"
            height="12px"
            borderRadius="9999px"
          />
        </div>
      </div>

      <div className="flex items-center gap-3 text-xs font-normal text-gray-500">
        <span className="inline-flex shrink-0 items-center gap-1">
          <Skeleton
            className={iconShimmerClassName}
            width="12px"
            height="12px"
            borderRadius="3px"
          />
          <Skeleton className={shimmerClassName} width="38px" height="10px" borderRadius="3px" />
        </span>
        <span className="inline-flex shrink-0 items-center gap-1">
          <Skeleton
            className={iconShimmerClassName}
            width="12px"
            height="12px"
            borderRadius="3px"
          />
          <Skeleton className={shimmerClassName} width="46px" height="10px" borderRadius="3px" />
        </span>
      </div>

      <div className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1 overflow-hidden">
        <span className="inline-flex min-w-0 max-w-full items-center gap-1">
          <Skeleton
            className={iconShimmerClassName}
            width="12px"
            height="12px"
            borderRadius="3px"
          />
          <Skeleton className={shimmerClassName} width="64px" height="10px" borderRadius="3px" />
        </span>
        <span className="inline-flex min-w-0 shrink items-center gap-1">
          <Skeleton
            className={iconShimmerClassName}
            width="12px"
            height="12px"
            borderRadius="3px"
          />
          <Skeleton className={shimmerClassName} width="52px" height="10px" borderRadius="3px" />
        </span>
      </div>

      <div className="flex items-center justify-between gap-x-3 text-xs font-normal text-gray-500">
        <span className="inline-flex min-w-0 items-center gap-1">
          <Skeleton
            className={iconShimmerClassName}
            width="12px"
            height="12px"
            borderRadius="3px"
          />
          <Skeleton className={shimmerClassName} width="54px" height="10px" borderRadius="3px" />
        </span>
        <Skeleton
          className={`${shimmerClassName} shrink-0`}
          width="72px"
          height="10px"
          borderRadius="3px"
        />
      </div>
    </div>
  </div>
);

export default SpanCardShimmer;
